let showPopupFn: (message: string) => void = null;
let hidePopupFn: () => void = null;

export function registerPopupControls(showFn: (message: string) => void, hideFn: () => void) {
    showPopupFn = showFn;
    hidePopupFn = hideFn;
}

export function showPopup(message = "Please wait, preparing your data..."): void {
    if (showPopupFn) showPopupFn(message);
}

export function hidePopup(): void {
    if (hidePopupFn) hidePopupFn();
}